import { History } from 'lucide-react';
import { useImportHistory } from '../../../hooks/useImportHistory';

const formatTimestamp = (iso: string) =>
  new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });

export const ImportHistorySection = () => {
  const { data: batches, isLoading, isError } = useImportHistory();

  return (
    <section id="import-history" className="border-t border-gray-200 px-6 py-8">
      <h3 className="flex items-center gap-2 text-base font-semibold text-gray-900">
        <History className="h-4 w-4 text-gray-500" aria-hidden />
        Import history
      </h3>

      {isError && (
        <p role="alert" className="mt-4 text-sm text-red-700">
          Couldn&apos;t load import history. Refresh the page to try again.
        </p>
      )}

      {!isLoading && !isError && (!batches || batches.length === 0) && (
        <p className="mt-4 text-sm text-gray-500">No imports yet. Past bulk uploads will show up here.</p>
      )}

      {batches && batches.length > 0 && (
        <ul className="mt-4 divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white">
          {batches.map((batch) => (
            <li key={batch.id} className="flex items-center justify-between gap-4 px-4 py-3 text-sm">
              <div>
                <p className="font-medium text-gray-900">{batch.filename}</p>
                <p className="text-xs text-gray-500">
                  {batch.adminName} · {formatTimestamp(batch.createdAt)}
                </p>
              </div>
              <span className="shrink-0 text-gray-700">{batch.rowCount} rows</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
